const reportTypes = {
  regular: 'Regular Support',
  received: 'Received Support',
  changes: 'Financial Partner Changes',
};

export default reportTypes;
